import {fetchCostCenters} from '../../services/costCenters';

const financialsColumns = ({costCenter}, {user}, state) => {
  const fieldTemp = [
  /*  {
      key: 'description',
      field: 'description',
      required: true,
      name: 'Descrição do produto/serviço',
      textAlign: 'center',
      width: costCenter === 'receitas' ? '200px' : '220px',
    },*/
    {
      key: 'cost_center',
      valueKey: 'cost_center.title',
      field: 'cost_center',
      required: true,
      name: 'Centro de custo',
      textAlign: 'center',
      width: costCenter === 'receitas' ? '320px' : '320px',
      optionsFetch: async () => {
        try {
          const response = await fetchCostCenters({
            type: costCenter.toUpperCase(),
            'order[title]': 'ASC',
          });
          return response.data.resultList.map(item => ({
            value: item.id,
            label: item.title,
          }));
        } catch (e) {
          return [];
        }
      },
    },
    {
      key: 'valueFormatted',
      field: 'valueFormatted',
      required: true,
      name: 'Valor (R$)',
      textAlign: 'center',
      width: '165px',
    },
  ];

  if (costCenter === 'receitas') {
    return [
      ...fieldTemp.slice(0, 3),
      {
        key: 'from_confinement',
        field: 'from_confinement',
        valueKey: 'from_confinement',
        name: 'Confinamento?',
        width: '80px',
        textAlign: 'center',
      },
      ...fieldTemp.slice(3, 5),
    ];
  }

  return fieldTemp;
};

export default financialsColumns;
